/* eslint-disable import/no-cycle */
import { all } from 'redux-saga/effects';
import initSaga from './components/init/initSaga';
import signinSaga from './components/signin/signinSaga';
import signupSaga from './components/signup/signupSaga';
import commandsSaga from './components/commands/commandsSaga';
import operationsSaga from './components/operations/operationsSaga';
import receptionsSaga from './components/receptions/receptionsSaga';
import courseSaga from './components/course/courseSaga';
import vouchersSaga from './components/vouchers/vouchersSaga';
import exportCommandsSaga from './components/exportCommands/exportCommandsSaga';
import exportsSaga from './components/exports/exportsSaga';
import stockSaga from './components/stock/stockSagas';
import userProfile from './components/userProfile/userProfileSaga';
import importCommandsSagas from './components/ImportCommands/importCommandsSagas';
import mergeCommandsSaga from './components/mergeCommands/mergeCommandsSaga';
import addCommandSaga from './components/addCommand/addCommandSaga';
import importProductsSaga from './components/importProducts/other/ImportProductsSaga';
import dashboardSaga from './components/dashboard/dashboardSaga';

export default function* rootSaga() {
  yield all([
    ...initSaga,
    ...signinSaga,
    ...signupSaga,
    ...commandsSaga,
    ...receptionsSaga,
    ...operationsSaga,
    ...courseSaga,
    ...vouchersSaga,
    ...exportCommandsSaga,
    ...exportsSaga,
    ...stockSaga,
    ...userProfile,
    ...importCommandsSagas,
    ...addCommandSaga,
    ...importProductsSaga,
    ...mergeCommandsSaga,
    ...dashboardSaga
  ]);
}
